import React from 'react';
import BranchePicker from '../../BranchePicker';

interface Props {
  authToken: string;
}

const BrancheSection: React.FC<Props> = ({ authToken }) => (
  <div>
    <h3 style={{ marginTop: 0 }}>Branche & Geschäftsmodell</h3>
    <p style={{ color: 'var(--ink-2)', marginBottom: 16, fontSize: 14 }}>
      Die Branche bestimmt welche Module und Agents für diesen Mandanten aktiv sind.
      Wechsel der Branche passt das Modul-Preset automatisch an.
    </p>
    <BranchePicker authToken={authToken} />
  </div>
);

export default BrancheSection;
